module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-联系我们banner.99b161e7.png";